import { render } from "./NotificationPrompt.vue?vue&type=template&id=0382b9df&scoped=true"
import script from "./NotificationPrompt.vue?vue&type=script&lang=js"
export * from "./NotificationPrompt.vue?vue&type=script&lang=js"

import "./NotificationPrompt.vue?vue&type=style&index=0&id=0382b9df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0382b9df"]])

export default __exports__